import ErrorMessage from './ErrorMessage';
import { Errors, localisedErrors } from './Errors';

// TODO this whole 'ErrorMessage<Errors>' functionality is a bit old from
// the start of webapp-v3. Would be nice to rethink this later.
export const createLocalisedErrorMessage = (errorMessageId: Errors) =>
  new ErrorMessage<Errors>(errorMessageId, localisedErrors[errorMessageId]);
